import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from 'components/Button';
import Paper from 'components/Paper';
import Input from 'components/Input';
import PasswordRules from 'components/PasswordRules';
import TextLink from 'components/TextLink';

const StyledChangePasswordView = styled.div`
  form {
    > * {
      margin-bottom: ${({ theme }) => theme.spacing * 4}px;

      &:last-child{
        margin-bottom:0;
      }
    }

    .currentPassword {
      margin-bottom: ${({ theme }) => theme.spacing * 2}px;
    }
  }

  ${Paper} {
    margin-bottom: ${({ theme }) => theme.spacing * 4}px;
  }

  .formCta {
    .Button:not(:last-child){
      margin-bottom: ${({ theme }) => theme.spacing * 2}px;
    }
  }
`;

const ChangePasswordView = ({
  className,
  error,
  onSubmit,
  onCancel,
  onChange,
  onForgotPassword,
}) => {
  const classes = ['ChangePasswordView'];
  const [value, setValue] = useState({
    currentPassword: '',
    newPassword: '',
    retypedPassword: '',
  });

  function handleSubmit(e) {
    e.preventDefault();
    onSubmit(value);
  }

  function handleChange(e) {
    setValue({ ...value, [e.target.name]: e.target.value });
    if (onChange) onChange(e.target.name, e.target.value);
  }

  if (className) classes.push(className);

  const formIsValid = value.currentPassword.length > 0
    && value.newPassword.length > 0
    && value.retypedPassword.length > 0
    && !error.code
    && !error.currentPassword
    && !error.newPassword
    && !error.retypedPassword;

  return (
    <StyledChangePasswordView className={classes.join(' ')}>
      <h1>Change password</h1>
      <p>
        Set your new easycare password
      </p>
      <Paper>
        <form onSubmit={handleSubmit} noValidate>
          <Input
            className="currentPassword"
            label="Current password"
            name="currentPassword"
            type="password"
            placeholder="Enter old password"
            value={value.currentPassword}
            error={error.currentPassword}
            onChange={handleChange}
          />
          <TextLink component="button" props={{ type: 'button' }} onClick={onForgotPassword} rightChevron>Forgot password</TextLink>
          <Input
            label="New password"
            name="newPassword"
            type="password"
            placeholder="Enter new password"
            value={value.newPassword}
            error={error.newPassword}
            onChange={handleChange}
          />
          <Input
            label="Confirm password"
            name="retypedPassword"
            type="password"
            placeholder="Re-enter new password"
            value={value.retypedPassword}
            error={error.retypedPassword}
            onChange={handleChange}
          />
          <PasswordRules />
          <div className="formCta">
            <Button
              type="submit"
              disabled={!formIsValid}
              fullWidth
              dataLayer={{ action: 'Change Password Confirmation Click', label: 'Change Password Confirmation' }}
            >
              Change password
            </Button>
            <Button
              inverse
              fullWidth
              type="button"
              onClick={onCancel}
              dataLayer={{ action: 'Change Password Cancel Click', label: 'Change Password Cancel' }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </Paper>
    </StyledChangePasswordView>
  );
};

ChangePasswordView.displayName = 'ChangePasswordView';

ChangePasswordView.propTypes = {
  className: PropTypes.string,
  error: PropTypes.shape({
    code: PropTypes.string,
    currentPassword: PropTypes.string,
    newPassword: PropTypes.string,
    retypedPassword: PropTypes.string,
  }),
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  onCancel: PropTypes.func,
  onForgotPassword: PropTypes.func.isRequired,
};

ChangePasswordView.defaultProps = {
  className: null,
  error: null,
  onChange: null,
  onCancel: null,
};

export default ChangePasswordView;
